import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { RadioGroup } from '@dojo/widgets/radio-group';
import { createNlsMiddleware, userstate, trackingWYLOChange } from 'lcc-state';
import { convertToBoolean } from '@holmescorp/common';
const nls = createNlsMiddleware('settings');
const factory = create({
    icache: createICacheMiddleware(),
    theme,
    nls,
    userstate
});
export const WhereYouLeftOffSetting = factory(({ middleware: { icache, theme, nls, userstate } }) => {
    const { messages: { wylo_checkbox = '[settings] wylo_checkbox', wylo_yes = '[settings] wylo_yes', wylo_no = '[settings] wylo_no' } } = nls();
    const { get, path } = userstate;
    const tracking = get(path('toolstate', 'trackingwylo'));
    const { always_resume } = tracking;
    const radios = w(RadioGroup, {
        name: 'alwaysresume',
        initialValue: `${always_resume}`,
        options: [
            { label: wylo_yes, value: 'true' },
            { label: wylo_no, value: 'false' }
        ],
        onValue: (value) => {
            icache.set('always_resume', value);
            trackingWYLOChange({ always_resume: convertToBoolean(value) });
        }
    });
    return v('div', {}, [v('fieldset', {}, [v('legend', {}, [wylo_checkbox]), radios])]);
});
export default WhereYouLeftOffSetting;
